import { createStore } from '@oneappexchange/lwc-wired';
import { State } from 'zustand';
import { IS_DEVELOPMENT } from '~/modules/config';
import { handleException } from '~/modules/utilities/error_utilities';
import { LegacyInstalls, LegacyInstallsState, LegacyListing, LegacyService } from '../services/legacyService';
import { logger } from '../utilities/logger';
import { i18nStore } from './i18nStore';

const legacyService = new LegacyService();

// README: I am thinking that our use case makes a site store more
// appropriate rather than a bunch of small type-specific stores.
//
// Please go through this code and consider and lets discuss.

// NOTE: the oaf schema types like BaseListing and BasePublisher are
// used here to get started easily.  We should consider whether we
// want services to keep using schema types or define UI types.

export interface LegacyState extends State {
    // user info contains things like name, auth'd, id, etc.
    // TODO userInfo: ???,

    // we should cache all listings initially and then do some
    // profiling to see what browser memory is looking like
    listings: Map<string, LegacyListing>;
    installs: LegacyInstallsState;
    isLoading: boolean;
}

const initialState: LegacyState = {
    listings: new Map<string, LegacyListing>(),
    installs: {
        isLoading: false,
        isError: false,
        isEmpty: false,
        errorMessage: '',
        installs: [],
        currentInstalls: '',
    },
    isLoading: false,
};

export const legacyStore = createStore(
    initialState,
    // the modifiers to the state - this could get long...?  this
    // is my main concern about a single store but I'm interested
    // to see how it goes

    (set: SetState<LegacyState>, get: GetState<LegacyState>) => ({
        setLoading(service: 'installs', state: boolean) {
            set(function setLoading(draft) {
                if (!draft[service]) {
                    draft[service] = initialState[service];
                }
                draft[service].isLoading = state;
                // if isLoading true then clear Error
                if (state) {
                    draft[service].isError = false;
                    draft[service].errorMessage = '';
                }
                return draft;
            });
        },
        setError(service: string, error: string) {
            set(function setError(draft) {
                logger.error(`Api ${service} has the following error; ${error}`);
                // @ts-expect-error * Automated Type Error Fix
                if (!draft[service]) {
                    // @ts-expect-error * Automated Type Error Fix
                    draft[service] = {};
                }
                // @ts-expect-error * Automated Type Error Fix
                draft[service].isError = true;
                // @ts-expect-error * Automated Type Error Fix
                draft[service].isLoading = false;
                // @ts-expect-error * Automated Type Error Fix
                draft[service].errorMessage = error;
                return draft;
            });
        },
        async fetchInstalls() {
            const installsSelector = get().installs;
            const hasRecords = installsSelector?.installs?.length > 0 && !installsSelector.isEmpty;
            const language = i18nStore.getState().currentLanguage;
            if (!hasRecords) {
                legacyStore.setLoading('installs', true);
                try {
                    const result: LegacyInstalls = await legacyService.getInstalls(
                        language,
                        i18nStore.getState().i18n.installs.logoText,
                    );

                    set(function setInstalls(draft: LegacyState) {
                        draft.installs.installs = result.installs;
                        draft.installs.currentInstalls = result.currentInstalls;
                    });
                    legacyStore.setLoading('installs', false);
                } catch (error) {
                    handleException(error, 'legacyStore.fetchInstalls');
                    legacyStore.setError('installs', error);
                }
            }
        },
        reset() {
            set(function reset() {
                return initialState;
            });
        },
    }),
    'legacyStore',
    IS_DEVELOPMENT,
);
